import {Component, Input, OnInit} from '@angular/core';
import {CommunicationService} from '../../services/communication.service';

@Component({
  selector: 'app-quebec-modal',
  templateUrl: './quebec-modal.component.html',
  styleUrls: ['./quebec-modal.component.scss', 'quebec-modal.desktop.component.scss']
})
export class QuebecModalComponent implements OnInit {
  @Input() showModal: boolean;

  constructor(private communicationService: CommunicationService) { }

  ngOnInit() {
  }

  closeQuebecModal() {
    this.communicationService.notifications.showQuebecModal.next(false);
  }
}
